import { api } from "./api";
import { ENDPOINTS } from "./endpoints";
import { operations } from "../types/openapi";

type getAllByRequestIdOperation = operations["getAllByRequestId"];
type approveQuoteOperation = operations["approve_1"];
type updateDefaultQuoteExpTimeOperation = operations["updateDefaultQuoteExpTime"];
type createQuoteOperation = operations["create_2"];
type getRateProxyOperation = operations["getRateProxy"];
type cancelQuoteOperation = operations["cancel_1"];
type extendQuoteOperation = operations["extend"];
type checkWalletWhitelistOperation = operations["check"];

/**
 * Грид котировок для заявки (LIQUIDITY_PROVIDER, OPERATOR)
 */
export const getQuotesList = (
  { requestId }: getAllByRequestIdOperation["parameters"]["path"],
  params: getAllByRequestIdOperation["parameters"]["query"]["criteria"]
): Promise<getAllByRequestIdOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.quotes(requestId), params);
};

/**
 * Выбрать котировку, переводит заявку в QUOTE_PROPOSED (OPERATOR)
 */
export const approveQuote = ({
  id,
}: approveQuoteOperation["parameters"]["path"]): Promise<approveQuoteOperation["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.approveQuote(id));
};

export const createQuote = (
  formData: Omit<createQuoteOperation["requestBody"]["content"]["application/json"], "quoteExpDuration"> & {
    quoteExpDuration: string | null;
  }
): Promise<createQuoteOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.createQuote(), formData, {
    contentType: "multipart/form-data",
  });
};

/**
 * Обновление времени экспирации котировки по умолчанию (доступно для LIQUIDITY_PROVIDER)
 */
export const updateDefaultQuoteExpTime = ({
  defaultQuoteExpDuration,
}: {
  defaultQuoteExpDuration: string | undefined;
}): Promise<updateDefaultQuoteExpTimeOperation["responses"]["200"]["content"]> => {
  return api.put(ENDPOINTS.defaultQuoteExpTime(), { defaultQuoteExpDuration });
};

/**
 * Получение времени экспирации котировки по умолчанию (доступно для LIQUIDITY_PROVIDER)
 */
export const getDefaultQuoteExpTime = (): Promise<string> => {
  return api.get(ENDPOINTS.defaultQuoteExpTime());
};

/**
 * Получение курса нативной валюты из внешних источников (LIQUIDITY_PROVIDER)
 */
export const getNativeCurrencyRate = ({
  network,
}: getRateProxyOperation["parameters"]["path"]): Promise<
  getRateProxyOperation["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.nativeCurrencyRate(network));
};

/**
 * Отменить котировку, переводит заявку в CANCELED (SENIOR_LP)
 */
export const cancelQuote = ({ id }: cancelQuoteOperation["parameters"]["path"]): Promise<string> => {
  return api.post(ENDPOINTS.cancelQuote(id));
};

/**
 * Запросить котировки
 */
export const getCollectQuote = ({ id }: { id: string }): Promise<string> => {
  return api.post(ENDPOINTS.getCollectQuote(id));
};

/**
 * Продлить время действия котировки
 */
export const extendQuote = ({
  id,
  newQuoteExpTime,
}: {
  id: string;
  newQuoteExpTime: string;
}): Promise<extendQuoteOperation["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.extendQuote(id), { newQuoteExpTime });
};

/**
 * Проверить адрес кошелька в белом списке (JUNIOR_LP, SENIOR_LP)
 */
export const checkWalletWhitelist = (
  params: checkWalletWhitelistOperation["requestBody"]["content"]["application/json"]
): Promise<checkWalletWhitelistOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.checkWalletWhitelist(), params);
};
